<template>
  <div>
    <div class="asc-descriptions-item">
      <span class="asc-descriptions-item--label">
        {{ label }}
      </span>
      <span class="asc-descriptions-item--content">{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AscDescriptionsItem',

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-descriptions-item > span {
  display: inline-block;
}

.asc-descriptions-item--label {
  font-weight: 500;
  white-space: nowrap;
  text-align: right;
  min-width: 150px;
  margin-right: 12px;
}
</style>
